module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4ba4257bf61c1879dd8136e4cc7787dd.png";